import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'gen-counter-element',
  templateUrl: './counter-element.component.html',
  styleUrls: ['./counter-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CounterElementComponent implements OnInit {
  @Input() counter: number;
  @Input() elementTitle: string;
  @Input() automationClass: string;
  constructor() { }

  ngOnInit() {
  }

}
